import { i18n } from '@/common/locale';

interface TranslationConstants {
  COMPARE_LAST: string;
  COMPARE_THIS: string;
  YESTERDAY: string;
  DAY: string;
  DAYS: string;
  WEEK: string;
  WEEKS: string;
  MONTH: string;
  MONTHS: string;
  DAY_OF_THE_WEEK_SHORT: {
    MON: string;
    TUE: string;
    WED: string;
    THU: string;
    FRI: string;
    SAT: string;
    SUN: string;
  };
}

export const DAYS_OFFSET_OBJ = {
  monday: 0,
  tuesday: 1,
  wednesday: 2,
  thursday: 3,
  friday: 4,
  saturday: 5,
  sunday: 6,
} as const;

let _translationConstants: TranslationConstants | null = null;

export const getTranslationConstants = (): TranslationConstants => {
  if (_translationConstants !== null) return _translationConstants;

  _translationConstants = {
    COMPARE_LAST: i18n.global.t('WORD.COMPARE_LAST'),
    COMPARE_THIS: i18n.global.t('WORD.COMPARE_THIS'),
    YESTERDAY: i18n.global.t('WORD.YESTERDAY'),
    DAY: i18n.global.t('WORD.DAY'),
    DAYS: i18n.global.t('WORD.DAYS'),
    WEEK: i18n.global.t('WORD.WEEK'),
    WEEKS: i18n.global.t('WORD.WEEKS'),
    MONTH: i18n.global.t('DESC.UI.MONTH'),
    MONTHS: i18n.global.t('DESC.UI.MONTHS'),
    DAY_OF_THE_WEEK_SHORT: {
      MON: i18n.global.t('WORD.COMPARE_MON'),
      TUE: i18n.global.t('WORD.COMPARE_TUE'),
      WED: i18n.global.t('WORD.COMPARE_WED'),
      THU: i18n.global.t('WORD.COMPARE_THU'),
      FRI: i18n.global.t('WORD.COMPARE_FRI'),
      SAT: i18n.global.t('WORD.COMPARE_SAT'),
      SUN: i18n.global.t('WORD.COMPARE_SUN'),
    },
  };

  return _translationConstants;
};
